module.exports = __webpack_public_path__ + "img/microplastics-process-7.3fd9be68.png";